import { render, staticRenderFns } from "./manage_organization_button.vue.js?vue&type=template&id=221085b0!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./manage_organization_button.vue?vue&type=template&id=221085b0"
import script from "./manage_organization_button.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./manage_organization_button.vue?vue&type=script&lang=js"
export * from "./manage_organization_button.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./manage_organization_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('221085b0')) {
      api.createRecord('221085b0', component.options)
    } else {
      api.reload('221085b0', component.options)
    }
    module.hot.accept("./manage_organization_button.vue.js?vue&type=template&id=221085b0!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./manage_organization_button.vue?vue&type=template&id=221085b0", function () {
      api.rerender('221085b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/manage_organization_button.vue"
export default component.exports